var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"vca-center avatar-container"},[_c('img',{attrs:{"src":_vm.avatarURL}})]),_c('br'),(_vm.current.avatar.file_id !== '')?_c('div',{staticClass:"vca-center"},[_c('vca-cancel-button',{attrs:{"placeholder":_vm.$t('button.delete')},on:{"click":function($event){return _vm.deleteAvatar()}}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }